import { apiClient } from "../../../api/client";
import * as ActionType from "./sellerRequest.type";
import { setToast } from "../../../util/toast";

export const getSellerRequest = () => async (dispatch) => {
  const res = await apiClient.get("sellerRequest/getAllSellerRequest");
  if (res.ok) {
    dispatch({ type: ActionType.GET_SELLER_REQUEST, payload: res.data?.sellerRequests });
  } else {
    console.log(res.message);
  }
};

export const acceptSellerRequest = (id) => async (dispatch) => {
  const res = await apiClient.patch(`sellerRequest/acceptSellerRequest?sellerRequestId=${id}`);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.ACCEPT_SELLER_REQUEST, payload: id });
    setToast("success", "Request accepted successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const sellerRequestUpdate = (formData, id) => async (dispatch) => {
  const res = await apiClient.patch(
    `sellerRequest/updateSellerRequest?sellerRequestId=${id}`,
    formData
  );
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.UPDATE_SELLER_REQUEST,
      payload: { updateRequest: res.data?.sellerRequest || res.data?.request },
    });
    setToast("success", "Request updated successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};
